import type { ReactNode } from 'react';
import { Card, CardHeader, CardTitle, CardBody, Divider } from '@vnetwork/ui/primitives';

/**
 * Shared bordered panel that wraps a per-type product configuration block so it
 * reads as one distinct unit, separated from the base product fields (group /
 * price / dates) above it. Titled header bar + padded body + optional full-width
 * footer strip (e.g. a readiness/summary recap). Extracted from the VCloud
 * builder so every per-type template (VCloud / CDN / Transcoding / Server.VBM)
 * shares identical chrome and real @ui tokens.
 */
export function TemplatePanel({
  title,
  footer,
  children,
}: {
  title: string;
  footer?: ReactNode;
  children: ReactNode;
}) {
  return (
    <Card>
      <CardHeader style={{ padding: 'var(--vn-space-2) var(--vn-space-4)' }}>
        <CardTitle>{title}</CardTitle>
      </CardHeader>

      <CardBody style={{ display: 'grid', gap: 'var(--vn-space-4)' }}>
        {children}
      </CardBody>

      {footer ? (
        <>
          <Divider />
          {footer}
        </>
      ) : null}
    </Card>
  );
}
